import React from "react";
import { useAppContext } from "../../helpers/account-context";

import { toPermalink, ICONS } from "../../helpers/helper";
import { ResultLine, DetailLine, InfowinLine } from "./Mixin";

const TagLink = (props) => {
  const { tag } = props;
  return (
    <div
    key={toPermalink(tag.name)}
    className={`cbmap-tag-name cbmap-tag_${toPermalink(tag.name)}`}
  >
    <span
      dangerouslySetInnerHTML={{
        __html: ICONS.CHECKED,
      }}
      className="cbmap-tag-icon"
    />
    {tag.name}
  </div>
  )
}

export const TagsResult = (props) => {
  const { account } = useAppContext()
  const { item } = props;
  const tagNames = item.properties.filter_groups || [];
  if (tagNames.length === 0) return null;
  const accountTags = account.tags || [];
  const itemTags = accountTags.filter((tag) => (tag.visibility === 'visible' &&  tagNames.find((tagName)=>(tagName===tag.name))))
  if(itemTags.length === 0) return null;

  return (
    <ResultLine className="cbmap-item_tags">
      {itemTags.map((tag) => (
        <TagLink
          key={`${tag.id}-${toPermalink(tag.name)}`}
          tag={tag}
        />

      ))}
    </ResultLine>
  );
};

export const TagsDetail = (props) => {
  const { account } = useAppContext();
  const { item } = props;
  const tagNames = item.properties.filter_groups || [];
  
  if (tagNames.length === 0) return null;
  const accountTags = account.tags || [];
  const itemTags = accountTags.filter((tag) => (tag.visibility === 'visible' &&  tagNames.find((tagName)=>(tagName===tag.name))))
  if(itemTags.length === 0) return null;

  return (
    <DetailLine className="cbmap-details_tags">
      {itemTags.map((tag) => (
        <TagLink
          key={`${tag.id}-${toPermalink(tag.name)}`}
          tag={tag}
        />

      ))}
    </DetailLine>
  );
};

export const TagsInfowin = (props) => {
  const { account } = useAppContext();

  const { item } = props;
  const tagNames = item.properties.filter_groups || [];
  
  if (tagNames.length === 0) return null;
  const accountTags = account.tags || [];
  const itemTags = accountTags.filter((tag) => (tag.visibility === 'visible' &&  tagNames.find((tagName)=>(tagName===tag.name))))
  if(itemTags.length === 0) return null;

  return (
    <InfowinLine className="cbmap-infowin_tags">
       {itemTags.map((tag) => (
       <TagLink
          key={`${tag.id}-${toPermalink(tag.name)}`}
          tag={tag}
        />
      ))}
    </InfowinLine>
  );
};
